import {ROUTES} from '@/routes/constants';

export const getActiveModuleName = (pathname) => {
  return Object.values(ROUTES)
    .filter((route) => route !== ROUTES.BASE)
    .find((route) => pathname.includes(route));
};
